/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TriggerVariableList } from '../../models/trigger-variable-list';

export interface GetTriggerVariables$Params {

/**
 * The trigger of a message
 */
  trigger: string;
}

export function getTriggerVariables(http: HttpClient, rootUrl: string, params: GetTriggerVariables$Params, context?: HttpContext): Observable<StrictHttpResponse<TriggerVariableList>> {
  const rb = new RequestBuilder(rootUrl, getTriggerVariables.PATH, 'get');
  if (params) {
    rb.path('trigger', params.trigger, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TriggerVariableList>;
    })
  );
}

getTriggerVariables.PATH = '/messages/triggers/{trigger}/variables';
